module.exports = __webpack_public_path__ + "static/media/contact_web.274890ad.png";